import block from './block.json';

export const introductionThemeAttributes = {
	color: '@tokens.variants.default.contentColor',
	typography: '@tokens.typographies.introduction',
	textAlignment: 'left',
};

export const IntroductionThemeControls: ThemeControlsType = {
	// name of the block
	title: block.title,

	// slug of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: introductionThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
